import './../scss/main.scss';
import App from 'App';
import { DomReady, getConfigBase, getDeviceMetric } from '@jollywise/jollygoodgame';
import { GameHudPlugin } from '@jollywise/jollygoodgame/src/components/gamehud/GameHudPlugin';
import Load from './app/scenes/Load';
import { CopyPuginTT } from './app/plugins/CopyPluginTT';
import { SceneControllerPluginTT } from './app/plugins/SceneControllerPluginTT';

const paths = { base: './', assets: 'assets/' };
const gameConfig = getConfigBase({
  components: {
    loader: { data: { displayScene: Load } },
    hud: GameHudPlugin,
    copy: CopyPuginTT,
    sceneController: SceneControllerPluginTT,
  },
  physics: false,
});

gameConfig.input = {
  windowEvents: true,
  mouse: {
    preventDefaultWheel: false,
  },
};

const params = new URLSearchParams(window.location.search);
const forceRender = params.get('renderer');
const forceLocale = params.get('locale') || GameSettings.language;
const forceTouch = params.get('touch');
if (forceRender && forceRender === 'canvas') gameConfig.type = Phaser.CANVAS;
if (forceRender && forceRender === 'webgl') gameConfig.type = Phaser.WEBGL;
if (forceTouch) gameConfig.forceTouch = true;

DomReady(() => {
  const config = { ...gameConfig, locale: forceLocale, urlParameters: params };
  new App({ config, paths });
});
